import { useQuery } from 'react-query';
import { ASSETS_CONVERT_API } from 'apis/Assets/convert';

// export const ASSETS_CACHE_KEY = 'assets';
export const PKR_TO_USD_CACHE_KEY = 'pkrToUsdConversion';

export const usePKRConversions = (opts = {}) =>
  useQuery(PKR_TO_USD_CACHE_KEY, ASSETS_CONVERT_API.convertPKRToUSD, opts);
